import styled, { css } from 'styled-components';

const VolumeSeekerStyled = styled.div`
  position: relative;
  pointer-events: all;
  ${({ isBlocked }) =>
    isBlocked &&
    css`
      opacity: 0.2;
      cursor: default !important;
      pointer-events: none;
    `};
`;

export default VolumeSeekerStyled;
